import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PipelinesIndex from "./PipelinesIndex";
import PipelinesCreate from "./PipelinesCreate";
import PipelinesEdit from "./PipelinesEdit";
import SEO from "../../src/View/UI/SEO/SEO";
const getPipelinesAdminBaseRoute = () => "/aviso/app/admin/pipelines";
const getPipelinesAdminBasePath = getPipelinesAdminBaseRoute;
export const getPipelinesAdminCreatePath = () => getPipelinesAdminBasePath() + "/create";
const getPipelinesAdminCreateRoute = () => getPipelinesAdminBasePath() + "/create";
export const getPipelinesAdminEditPath = (pipelineId) => getPipelinesAdminBasePath() + "/edit/" + pipelineId;
const getPipelinesAdminEditRoute = () => getPipelinesAdminEditPath(":pipelineId");
export const getPipelinesAdminListPath = getPipelinesAdminBasePath;
const getPipelinesAdminListRoute = getPipelinesAdminBaseRoute;
const PipelinesAdmin = () => (_jsxs(Router, { children: [_jsx(SEO, { title: "Pipelines" }), _jsxs(Switch, { children: [_jsx(Route, { component: PipelinesCreate, path: getPipelinesAdminCreateRoute() }), _jsx(Route, { component: PipelinesEdit, path: getPipelinesAdminEditRoute() }), _jsx(Route, { component: PipelinesIndex, path: getPipelinesAdminListRoute() })] })] }));
export default PipelinesAdmin;
